export const getArrayElementWidthByNodeElements = (nodeElement: NodeListOf<Element>) => {
  let result: number[] = [];
  nodeElement?.forEach((node) => {
    if (node?.clientWidth) {
      result.push(node?.clientWidth);
    }
  });
  return result;
};
